import React, { SVGProps } from 'react'

interface ManufacturingIconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
  strokeWidth?: number
}

export function ManufacturingIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  ...props
}: ManufacturingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Gear 1 */}
      <circle cx="8" cy="8" r="3" />
      <path d="M8 4v1" />
      <path d="M8 11v1" />
      <path d="M4 8h1" />
      <path d="M11 8h1" />
      <path d="M5.17 5.17l.71.71" />
      <path d="M10.12 10.12l.71.71" />
      <path d="M5.17 10.83l.71-.71" />
      <path d="M10.12 5.88l.71-.71" />
      {/* Gear 2 */}
      <circle cx="16" cy="16" r="3" />
      <path d="M16 12v1" />
      <path d="M16 19v1" />
      <path d="M12 16h1" />
      <path d="M19 16h1" />
      {/* Connection */}
      <path d="M10.5 10.5l3 3" />
    </svg>
  )
}
